"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _helpers = require("vuelidate/lib/validators/common");

var _default = value => {
  // required
  if (value === undefined || value === null) {
    return true;
  }

  // exact length of 9
  if (_helpers.len(value) !== 9) {
    return false;
  }

  // only numbers
  if (!/^\d*$/.test(value)) {
    return false;
  }

  return true;
};

exports.default = _default;
